import React from "react";
import useFormWrapper from "utils/custom-hooks/useFormWrapper";
// import useFieldDisabler from "utils/custom-hooks/useFieldDisabler";
import { Controller } from "react-hook-form";
import StewartAutocompleteWithCheckboxes, { OptionRenderType, StewartAutocompleteEventType } from "./StewartMultiSelect";
import ErrorMessage from "../error-message";
import useFieldDisabler from "utils/custom-hooks/useFieldDisabler";

interface Props  {
    label: string;
    name: string;
    defaultValue?: any;
    options: any[]; // Array<MultiSelectFieldOption>;
    disabled?: boolean;
    productIndex?: number;
    onChange?: (
      e: StewartAutocompleteEventType,
      value: OptionRenderType[],
      selectedOption?: OptionRenderType
    ) => void;  
    onTouched?: () => void;
    excludeFromDisplayValue?: string[];
    disableAutoSelectSingle?: boolean;
    shouldSetDefaultSelectedValue?: boolean;
}

export default function StewartMultiSelectField ({
  label,
  name,
  defaultValue,
  options,
  disabled,
  productIndex,
  onChange,
  onTouched,
  excludeFromDisplayValue,
  disableAutoSelectSingle,
  shouldSetDefaultSelectedValue = false,
}:Props) {

  const { control, setValue } = useFormWrapper();
  // const shouldFieldBeDisabled = useFieldDisabler(name.toString());

  const shouldFieldBeDisabled = useFieldDisabler(name);

  return (
    <>
      <Controller 
        control={control}
        name={name}
        defaultValue={defaultValue}
        render={({field}) => {
          // console.log(field);
          return (
            <StewartAutocompleteWithCheckboxes
              {...field}
              name={name}
              placeholder={label}
              options={options}
              defaultSelectedOption={field.value}
              onChange={(event, value, selectedOption) => {
                // console.log("name:", name);
                // console.log("value:", value);
                setValue(name, value);
                onTouched?.();
                onChange?.(event, value, selectedOption);
              }}
              disabled={disabled || shouldFieldBeDisabled}
              excludeFromDisplayValue={excludeFromDisplayValue}
              disableAutoSelectSingle={disableAutoSelectSingle}
              shouldSetDefaultSelectedValue={shouldSetDefaultSelectedValue}
            />

          );
        }}

      />
      <ErrorMessage name={name} />      
    </>
  );
}